// This browser's MCR location (DECISIONS 2026-10-06 "the cloud relay"): a
// viewer at a location watches through its relay. Chosen once on the watch
// or wall page and remembered in this browser (0: direct to the nodes).
import { ref, watch } from 'vue'

function stored(): number {
    try {
        return Number(localStorage.getItem('ese.location') ?? 0) || 0
    } catch {
        return 0 // storage blocked: direct
    }
}
export const location = ref(stored())
watch(location, (id) => {
    try {
        localStorage.setItem('ese.location', String(id))
    } catch {
        // storage blocked: this page keeps it
    }
})
